<div class="decisionImg-item" [ngClass]="imgQualityClass + ' ' + imgType"></div>

<div *ngFor="let score of scores" class="globalNotation">
     <span class="globalNotation-label" [i18nKey]="score.label"></span>
     <div class="starsContainer">
         <div [style.width.%]="score.value" class="stars"></div>
     </div>
 </div>
